import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { reportService } from '../services/api';
import ReportPreviewSection from '../components/ReportPreviewSection';
import styles from './CreateReportPage.module.css';

function formatDate(str) {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('ar-SY', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function ReportViewPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [report,  setReport]  = useState(null);
    const [loading, setLoading] = useState(true);
    const [error,   setError]   = useState(null);

    useEffect(() => {
        reportService.get(id)
            .then((r) => setReport(r.data))
            .catch(() => setError('تعذر تحميل التقرير'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return (
        <div className={`${styles.page} text-ar`} style={{ paddingTop: 80, textAlign: 'center', color: 'var(--text-secondary)' }}>
            جاري التحميل...
        </div>
    );

    if (error) return (
        <div className={`${styles.page} text-ar`} style={{ paddingTop: 80, textAlign: 'center', color: 'var(--danger)' }}>
            {error}
        </div>
    );

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.header}>
                <button className={styles.closeBtn} onClick={() => navigate('/reports')}>← العودة</button>
                <div>
                    <h1 className={styles.heading}>{report.title}</h1>
                    {report.description && (
                        <p className={styles.subheading}>{report.description}</p>
                    )}
                    <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', margin: '2px 0 0' }}>
                        تاريخ الإنشاء: {formatDate(report.generated_at)}
                    </p>
                </div>
            </div>

            <div className={styles.card}>
                <ReportPreviewSection
                    reportData={report.report_data ?? {}}
                    selectedMetrics={report.selected_metrics ?? {}}
                    chartTypes={report.chart_types ?? {}}
                    protestsCount={report.report_data?.total_protests}
                    onSave={null}
                    onBack={null}
                    saving={false}
                />
            </div>
        </div>
    );
}
